import React from 'react';
import * as Sentry from '@sentry/react';

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ComponentType<any>;
}

const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ 
  children, 
  fallback: Fallback 
}) => {
  const CustomFallback = ({ error, resetError }: { error: unknown; resetError: () => void }) => {
    const errorObj = error instanceof Error ? error : new Error(String(error));
    
    if (Fallback) {
      return <Fallback error={errorObj} resetError={resetError} />;
    }

    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        margin: '20px'
      }}>
        <h2 style={{ color: '#dc3545', marginBottom: '16px' }}>
          Une erreur inattendue s'est produite
        </h2>
        <p style={{ color: '#6c757d', marginBottom: '20px' }}>
          Nous avons été notifiés de cette erreur et travaillons à la résoudre.
        </p>
        <button 
          onClick={resetError}
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Réessayer
        </button>
        {process.env.NODE_ENV === 'development' && (
          <details style={{ marginTop: '20px', textAlign: 'left' }}>
            <summary style={{ cursor: 'pointer', color: '#6c757d' }}>
              Détails de l'erreur (développement)
            </summary>
            <pre style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '10px', 
              borderRadius: '4px',
              overflow: 'auto',
              fontSize: '12px'
            }}>
              {errorObj.stack}
            </pre>
          </details>
        )}
      </div>
    );
  };

  return (
    <Sentry.ErrorBoundary fallback={CustomFallback} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export { SentryErrorBoundary };

